<template>
  <div class="MultiSelect mx-2">
    <div v-for="collection in shownCollections" class="flex items-center">
      <label
        :for="labelName(collection.value)"
        :class="isSelected(collection.value) && 'active'"
        class="MultiSelect_label font-normal my-2 flex items-center"
      >
        <input
          class="offscreen"
          type="checkbox"
          :id="labelName(collection.value)"
          :value="collection.value"
          @change="toggleCheckbox"
          :name="collection.value"
          :checked="isSelected(collection.value)"
        />

        <span class="inline-block mr-2 fa-layers fa-2x">
          <i class="fal fa-square unchecked"></i>
          <i class="fal fa-check-square checked"></i>
        </span>
        <a
          :href="url(type, selected, collection.value)"
          class="text-grey-regular hover:text-grey-regular hover:no-underline focus:text-grey-regular focus:no-underline cursor-default"
          v-if="url"
        >
          {{ collection.title }}
        </a>
        <template v-else>
          {{ collection.title }}
        </template>
      </label>

      <span class="inline-block ml-auto" v-if="collection['caption']"> ({{ collection.caption }}) </span>
    </div>
    <div v-if="!showMore">
      <br />
      <a href="#" @click.prevent="showMore = !showMore" class="text-base text-black">See All +</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Side.MultiSelect",
  props: {
    url: { type: Function },
    collections: Array,
    selected: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      required: true,
    },
    showMax: {
      type: Number,
    },
  },
  data() {
    return {
      showMore: this.showMax ? false : true,
    }
  },
  methods: {
    labelName(label) {
      return `${this.type}-${label}-checkbox`
    },
    isSelected(value) {
      return this.selected.includes(value)
    },
    toggleCheckbox(e) {
      const { checked, value } = e.target
      checked ? this.add(value) : this.remove(value)
    },
    add(value) {
      this.$emit("select", { [this.type]: [...this.selected, value] })
    },
    remove(value) {
      this.$emit("select", { [this.type]: this.selected.filter((filter) => value != filter) })
    },
  },
  computed: {
    shownCollections() {
      return this.collections && this.showMax && !this.showMore
        ? this.collections.slice(0, this.showMax)
        : this.collections
    },
  },
}
</script>

<style scoped>
.MultiSelect_label .checked {
  display: none;
}

.MultiSelect_label.active .unchecked {
  display: none;
}

.MultiSelect_label.active .checked {
  @apply text-primary;
  display: inline-block;
}
</style>
